import { withInstall } from '@park-ui/utils'

import Divider from './src/divider.vue'

export const ElDivider = withInstall(Divider)
export default ElDivider

export * from './src/divider'
